// @ts-nocheck
import { DRAWER_VISIBILITY_CHANGED, SIDER_COLLAPSED, SIDER_EXPANDED } from '../types';

export const collapseSider = () => ({
    type: SIDER_COLLAPSED,
});

export const expandSider = () => ({
    type: SIDER_EXPANDED,
});

export const changeDrawerVisibility = visible => ({
    type: DRAWER_VISIBILITY_CHANGED,
    payload: visible,
});
